import { booleanToSimNaoEnum, simNaoEnumRecord } from 'components/form'
import { AtendimentoProfissional, Problema } from 'graphql/types.generated'
import { isUndefinedOrNull } from 'util/checks'
import { formatDate } from 'util/date/formatDate'
import { formatNumber } from 'util/number'
import { isEmpty } from 'util/validation/Util'

import { MedicoesPreNatal } from '../../components/modals/types/model-historicoPreNatal'
import { convertMedicoesUltimaGestacao } from '../../soap/aside/pre-natal/converter-acompanhamentoPreNatal'
import { CIAPS_GESTACAO_CODIGOS, CIDS_GESTACAO_CODIGOS } from '../../soap/pre-natal/model-preNatal'
import {
  MedicaoField,
  MEDICOES_ACOMPANHAMENTO_PRE_NATAL,
  MedicoesAcompanhamentoPreNatal,
} from './model-acompanhamentoPreNatal'

const NAO_INFORMADO = '—'

export const sortProblemasPreNatal = (a: Problema, b: Problema) => {
  const aIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(a.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(a.cid10?.codigo)
  const bIsInPreNatal = CIAPS_GESTACAO_CODIGOS.has(b.ciap?.codigo) || CIDS_GESTACAO_CODIGOS.has(b.cid10?.codigo)

  if (aIsInPreNatal && !bIsInPreNatal) {
    return -1
  }

  if (!aIsInPreNatal && bIsInPreNatal) {
    return 1
  }

  return 0
}

export const getMedicoesPreNatal = (atendimentosProfUltimaGestacao: AtendimentoProfissional[]) => {
  return atendimentosProfUltimaGestacao?.map((atendProf, index) => {
    const medicao = !isEmpty(atendProf.medicoes) ? atendProf.medicoes[0] : null
    const dataMedicao = medicao?.dataMedicao ?? atendProf.iniciadoEm
    return convertMedicoesUltimaGestacao(index, medicao, atendProf.atendimentoProfissionalPreNatal, dataMedicao)
  })
}

export const convertToUltimasMedicoesRegistradas = (
  medicoesPreNatal: MedicoesPreNatal[]
): MedicoesAcompanhamentoPreNatal => {
  const ultimasMedicoesPreNatal: MedicoesAcompanhamentoPreNatal = {}

  const ordenadas = medicoesPreNatal?.sort((a, b) => b.numeroConsulta - a.numeroConsulta)

  MEDICOES_ACOMPANHAMENTO_PRE_NATAL.forEach((key) => {
    const campo = key as keyof MedicoesPreNatal
    const registroMaisRecente = ordenadas?.find((valor) => !isEmpty(valor[campo]))

    if (registroMaisRecente) {
      ultimasMedicoesPreNatal[campo] = {
        medicao: registroMaisRecente[campo],
        dataMedicao: registroMaisRecente.dataDaMedicao,
      }
    }
  })

  return ultimasMedicoesPreNatal
}

// TODO Royal Flush - Considerar os valores de pressão arterial e peso registrados em outras consultas além do pré-natal #27365

/** 
const calculateMedicoesAntropometricas = (
  ultimasMedicoesPreNatal: MedicoesAcompanhamentoPreNatal,
  medicoes: MedicoesAtendimentoAnterior[],
  dataAtual: Date
): MedicoesAcompanhamentoPreNatal => {
  const medicoesSorted = medicoes?.sort((a, b) => b.dataMedicao - a.dataMedicao)

  const ultimaPressaoArterial = medicoesSorted?.find((medicao) => !isEmpty(medicao.valorPressaoArterial))

  if (ultimaPressaoArterial) {
    ultimasMedicoesPreNatal.pressaoArterial = {
      medicao: ultimaPressaoArterial.valorPressaoArterial,
      dataMedicao: ultimaPressaoArterial.dataMedicao,
    }
  }

  const ultimoPeso = medicoesSorted?.find((medicao) => !isEmpty(medicao.valorPeso))

  if (!ultimoPeso) return ultimasMedicoesPreNatal

  const { valorPeso, dataMedicao } = ultimoPeso
  const hasPesoPreNatal = !isEmpty(ultimasMedicoesPreNatal.peso)

  const dataPesoMaisRecente = hasPesoPreNatal
    ? closestTo(dataAtual, [dataMedicao, toDate(ultimasMedicoesPreNatal.peso.dataMedicao)])
    : dataMedicao

  const isPesoMaisRecente = isSameDateAndTime(dataMedicao, dataPesoMaisRecente)

  if (!hasPesoPreNatal || isPesoMaisRecente) {
    ultimasMedicoesPreNatal.peso = {
      medicao: valorPeso,
      dataMedicao: dataMedicao,
    }
  }

  return ultimasMedicoesPreNatal
}

const isSameDateAndTime = (date1: Date, date2: Date): boolean => {
  return dateAsYyyyMmDdHhMmSs(date1) === dateAsYyyyMmDdHhMmSs(date2)
}
*/

export const formatMedicaoString = (valor: MedicaoField<any>, unidadeMedida: string = ''): string => {
  return !isEmpty(valor) ? `${valor.medicao}${unidadeMedida} | ${formatDate(valor.dataMedicao)}` : NAO_INFORMADO
}

export const formatPesoString = (valor: MedicaoField<any>, pesoReferencia?: number): string => {
  const ganhoPeso = computeGanhoDePeso(pesoReferencia, valor?.medicao)
  return !isEmpty(ganhoPeso) ? `${ganhoPeso}kg | ${formatDate(valor?.dataMedicao)}` : NAO_INFORMADO
}

export const formatMovimentacaoFetalString = (valor: MedicaoField<boolean>): string => {
  const label = simNaoEnumRecord[booleanToSimNaoEnum(valor?.medicao)]
  const hasMedicao = !isEmpty(valor?.medicao)

  return hasMedicao ? `${label} | ${formatDate(valor?.dataMedicao)}` : NAO_INFORMADO
}

export function computeGanhoDePeso(pesoReferencia: number, pesoConsulta: number): string {
  if (isUndefinedOrNull(pesoReferencia) || isUndefinedOrNull(pesoConsulta)) return null

  const ganhoPeso = Math.abs(pesoConsulta - pesoReferencia)
  const ganhoPesoFormatted = formatNumber(ganhoPeso)

  return ganhoPesoFormatted
}
